<template>
    <div>
        <br>
        <br>
        <div class="table-responsive">
            <div ref="heatmap"></div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import _ from 'lodash'
    import CalHeatMap from 'cal-heatmap'
    import eventBus from '../../modules/eventBus'

    const heatmaps = {}

    function customizer (objValue, srcValue) {
        return objValue + srcValue
    }

    export default {
        name: 'dashboard-heatmap',
        props: {
            type: {
                type: String
            },
            data: {
                type: Object
            }
        },
        data () {
            return {
                date: null,
                heatmap: null
            }
        },
        watch: {
            date (date) {
                const data = {
                    date: date,
                    period: 'day',
                    source: 'heatmap'
                }
                eventBus.emit('change', data)
            },
            data (data) {
                this.show(data)
            }
        },
        methods: {
            show (input) {
                const legendColors = this.getLegendColor(this.type)
                const data = this.type === 'total' ? _.mergeWith(_.clone(input['hot']), _.clone(input['cold']), customizer) : input[this.type]
                const keys = _.keys(data)
                const minDate = keys.length > 0 ? moment(_.min(keys) * 1000) : moment()
                const maxDate = keys.length > 0 ? moment(_.max(keys) * 1000) : moment()
                const lastDayOfMonth = new Date(maxDate.year(), maxDate.month() + 1, 0)
                const legend = this.getLegendRange(_.max(_.values(data)))
                const self = this
                const init = {
                    itemSelector: this.$refs.heatmap,
                    range: maxDate ? (maxDate.date() === lastDayOfMonth.getDate() ? 12 : 13) : 13,
                    domain: 'month',
                    // subdomain: 'day',
                    domainGutter: 2,
                    cellSize: 9,
                    subDomain: 'day',
                    itemName: ['l', 'l'],
                    subDomainTitleFormat: {
                        filled: '{count} {name} {date}'
                    },
                    start: minDate.toDate(),
                    minDate: minDate.toDate(),
                    maxDate: maxDate.toDate(),
                    legendColors: legendColors,
                    legend: legend,
                    data: data,
                    subDomainDateFormat (date) {
                        let m = moment(date)
                        m = m.add(-date.getTimezoneOffset(), 'm')
                        return m.format('dddd LL')
                    },
                    domainLabelFormat (date) {
                        let m = moment(date)
                        m = m.add(-date.getTimezoneOffset(), 'm')
                        return m.format('MMMM')
                    },
                    onClick (date) {
                        if (moment(date) <= moment()) {
                            let m = moment(date)
                            m = m.add(-date.getTimezoneOffset(), 'm')
                            self.date = m.format('DD.MM.YYYY')
                        }
                    }
                }
                if (heatmaps[this.type]) {
                    heatmaps[this.type].destroy()
                }
                let heatmap = new CalHeatMap()
                heatmap.init(init)
                heatmaps[this.type] = heatmap
            },
            getLegendColor (type) {
                return { // 5afb24
                    heat: {
                        empty: '#ededed',
                        min: '#ceadff',
                        max: '#7a24fb'
                    },
                    gas: {
                        empty: '#ededed',
                        min: '#b3c7ab',
                        max: '#4db32d'
                    },
                    power: {
                        empty: '#ededed',
                        min: '#fffbeb',
                        max: '#fbbf24'
                    },
                    cold: {
                        empty: '#ededed',
                        min: '#d9deff',
                        max: '#428bca'
                    },
                    hot: {
                        empty: '#ededed',
                        min: '#ffc1c3',
                        max: '#c9302c'
                    },
                    total: {
                        empty: '#ededed',
                        min: '#e0f7fa',
                        max: '#00bcd4'
                    }
                }[type]
            },
            getLegendRange (max = 5) {
                const values = [1, 2, 3, 4]
                const unit = Math.floor((max / 5) + 0.5)
                if (unit < 1) {
                    return values
                }
                return _.map(values, (n) => {
                    return (unit * n)
                })
            }
        },
        mounted () {
            if (this.data) {
                this.show(this.data)
            }
        }
    }
</script>

<style scoped>

</style>
